<template>
  <div class="main-container p-3">
    <KidHeader :profileId="profileId" :serialNumber="serialNumber" />

    <!-- Back to Home outside filter -->
    <div class="back-home text-left mb-3">
      <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query: { profileId: this.profileId, serialNumber: serialNumber } })">
        <i class="fas fa-arrow-left"></i> <b>Back to Home</b>
      </a>
    </div>

    <!-- Filters Section -->
    <div class="filters-row">
      
      <div class="filter-item">
        <label>Filter by Type</label>
        <select v-model="reportType">
          <option value="">All</option>
          <option v-for="type in reportTypeArray" :key="type.label" :value="type.label">{{ type.label }}</option>
        </select>
      </div>
      <!-- Month Filter -->
      <div class="filter-item">
        <label>Filter by Month</label>
        <select v-model="selectedMonth">
          <option value="">All</option>
          <option v-for="month in months" :key="month.label" :value="month.label">{{ month.label }}</option>
        </select>
      </div>

      <!-- Year Filter -->
      <div class="filter-item">
        <label>Filter by Year</label>
        <select v-model="selectedYear">
          <option value="">All</option>
          <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>

      <!-- Search Button -->
      <div class="filter-item search-btn">
        <label>&nbsp;</label>
        <button @click="getReportList">
          <i class="fas fa-search"></i> Search
        </button>
      </div>
    </div>

    <!-- Report List -->
    <div v-if="reportsData.length">
      <table class="table table-striped table-hover align-middle">
        <thead class="table-primary">
          <tr>
            <th>Report Title</th>
            <th class="text-center">Total Usage</th>
            <th class="text-center">Change</th>
            <th class="text-center" style="width: 100px;">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="report in reportsData" :key="report._id">
            <!-- ✅ Title without prefix -->
            <td>
              {{ report.reportTitle.replace(/^Weekly Screen Time Report:\s*/i, '') }}
              <span
                v-if="report.weeklyUsage"
                class="badge badge-monthly"
              >
                Monthly
              </span>

              <span
                v-else
                class="badge badge-weekly"
              >
                Weekly
              </span>
            </td>

            <!-- 📊 Total Screen Time -->
            <td class="text-center">
              <strong>{{ report.totalScreenTime }}</strong>
            </td>

            <!-- 📈 Percentage Change with Icon + Color -->
            <td class="text-center">
              <span
                v-if="report.direction === 'up'"
                class="text-danger fw-bold"
              >
                <i class="fas fa-arrow-up me-1"></i>
                {{ report.message }}
              </span>

              <span
                v-else-if="report.direction === 'down'"
                class="text-success fw-bold"
              >
                <i class="fas fa-arrow-down me-1"></i>
                {{ report.message }}
              </span>

              <span
                v-else
                class="text-secondary fw-bold"
              >
                <i class="fas fa-minus me-1"></i>
                {{ report.message }}
              </span>
            </td>

            <!-- 🔍 View Action -->
            <td class="text-center">
              <a
                href="javascript:void(0)"
                @click="$router.push({ path: '/report', query: { id: report._id, serialNumber: serialNumber, profileId: profileId } })"
                title="View Report"
                class="text-primary"
              >
                <i class="fas fa-eye"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="no-report-msg">
      No reports found.
    </div>
    <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
  </div>
</template>


<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";
const currentYear = new Date().getFullYear();

export default {
  name: 'Change Password',
  components: {
    KidHeader,
    KidFooter,
  },
  data() {
    return {
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        isDisabled: false,
        reportsData: [],
        selectedMonth: "",
        selectedYear: "",
        months: [
            { label: "January", value: 0 },
            { label: "February", value: 1 },
            { label: "March", value: 2 },
            { label: "April", value: 3 },
            { label: "May", value: 4 },
            { label: "June", value: 5 },
            { label: "July", value: 6 },
            { label: "August", value: 7 },
            { label: "September", value: 8 },
            { label: "October", value: 9 },
            { label: "November", value: 10 },
            { label: "December", value: 11 }
        ],
        reportType: "",
        reportTypeArray: [
          { label: "Weekly", value: "Weekly" },
          { label: "Monthly", value: "Monthly" },
        ],
        years: Array.from({ length: 5 }, (_, i) => currentYear - i)
    }
  },
  methods: {
    async getReportList() {
        const data = {
            serialNumber: this.serialNumber,
            profileId: this.profileId,
            year: this.selectedYear,
            month: this.selectedMonth,
            reportType: this.reportType
        };

        await KidsService.getReportList(data)
        .then((response) => {
          this.reportsData = response.data.data
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    },
  },
  beforeMount() {
    this.getReportList();
  },
}
</script>
<style scoped>
@media (max-width: 576px) {
  .filters-row {
    flex-wrap: nowrap !important;
    justify-content: center !important;
    gap: 15px !important;
    max-width: 100%;
    box-sizing: border-box;
  }

  /* Month and Year filters side by side */
  .filters-row > .filter-item:nth-child(1),
  .filters-row > .filter-item:nth-child(2) {
    flex: 1 1 40% !important;
    min-width: 0 !important; /* Allow shrinking */
  }

  /* Search button on next line, full width but centered */
  .filters-row > .filter-item.search-btn {
    flex-basis: 100% !important;
    margin-top: 8px !important;
    text-align: center !important;
  }

  /* Remove label space above search button */
  .filters-row > .filter-item.search-btn label {
    display: none !important;
  }
}

select.form-control {
  width: 100%;
  max-width: 250px;
}

label.form-label {
  font-weight: 600;
}

/* Back to home button styling */
.back-home {
  font-size: 1rem;
}

/* Filters Row - flex by default */
.filters-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: flex-end;
  margin-bottom: 25px;

  max-width: 100%;
  box-sizing: border-box; /* ensure padding/borders included in width */
  overflow-x: hidden; /* prevent horizontal scroll */
}

/* Each filter block */
.filter-item {
  display: flex;
  flex-direction: column;
  /* Removed min-width: 160px to prevent overflow */
  flex: 1 1 auto; /* allow flexible widths */
  min-width: 0; /* allow shrinking inside flex container */
}

/* Label styling */
.filter-item label {
  font-weight: 600;
  margin-bottom: 5px;
}

/* Select and button styling */
.filter-item select,
.filter-item button {
  padding: 8px;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 100%;
  box-sizing: border-box;
}

/* Search button colors */
.search-btn button {
  background-color: #007bff;
  color: white;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.search-btn button:hover {
  background-color: #0056b3;
}

/* Table styling */
table {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
}

.back-home {
  display: block;         /* Make it block level */
  width: 100%;            /* Full width */
  margin-bottom: 15px;    /* Space below back button */
}

/* Optional: add spacing between back button text and filters on desktop */
@media (min-width: 576px) {
  .back-home {
    margin-bottom: 25px;
  }
}
.no-report-msg {
  width: 100%;
  display: block;
  margin-top: 30px;
  margin-bottom: 80px;
  padding: 20px;
  text-align: center;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-size: 16px;
  color: #6c757d;
}
.back-home {
  display: block;         /* Make it block level */
  width: 100%;            /* Full width */
  margin-bottom: 15px;
  font-size: 1rem;
}

.badge {
  margin-left: 8px;
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 4px;
}

.badge-monthly {
  background-color: #4caf50;
  color: #fff;
}

.badge-weekly {
  background-color: #2196f3;
  color: #fff;
}

</style>
